
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

interface UserDeleteActionProps {
  userId: string;
  onDeleteUser: (userId: string) => Promise<void>;
}

export function UserDeleteAction({ userId, onDeleteUser }: UserDeleteActionProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="icon" className="text-destructive hover:text-destructive hover:bg-destructive/10">
          <Trash2 className="h-4 w-4" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="font-subtitle border border-accent-light/30">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-title text-primary">Delete User</AlertDialogTitle>
          <AlertDialogDescription className="font-body">
            Are you sure you want to delete this user? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="font-subtitle">
          <AlertDialogCancel className="border-accent-light/30 text-primary hover:bg-accent-subtle">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => onDeleteUser(userId)}
            className="bg-destructive hover:bg-destructive/90 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
